var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForwardRed1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.313,
    height: 91.59,
    viewBox: "0 0 99.313 91.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46805",
    "data-name": "Group 46805",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197124",
    "data-name": "Path 197124",
    d: "M245.693,228.959c1.376,0,3.793-3.68,23.157-12.357l-.224,11.905a1.152,1.152,0,0,0,1.129,1.172h.021a1.15,1.15,0,0,0,1.15-1.129L271.5,198.1a1.151,1.151,0,0,0-1.128-1.172,1.133,1.133,0,0,0-1.173,1.129l-.3,15.795c-7.366-7.341-14.9-14.214-21.813-21.152a1.151,1.151,0,0,0-1.965.793l-.579,34.294a1.15,1.15,0,0,0,1.15,1.17Z",
    transform: "translate(-215.973 -164.089)",
    fill: "#f82121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197125",
    "data-name": "Path 197125",
    d: "M524.646,51.868,523.776,56a1.149,1.149,0,1,0,2.249.475l.87-4.132a1.149,1.149,0,1,0-2.249-.475Z",
    transform: "translate(-439.355 -50.956)",
    fill: "#f82121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197126",
    "data-name": "Path 197126",
    d: "M557.393,67.061l6.079-5.233a1.15,1.15,0,1,0-1.5-1.743l-6.079,5.233a1.15,1.15,0,1,0,1.5,1.743Z",
    transform: "translate(-464.75 -58.036)",
    fill: "#f82121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197127",
    "data-name": "Path 197127",
    d: "M552.071,116.038a1.149,1.149,0,0,0,.878,1.369l6.959,1.523a1.151,1.151,0,0,0,.491-2.249l-6.959-1.521A1.154,1.154,0,0,0,552.071,116.038Z",
    transform: "translate(-461.992 -102.301)",
    fill: "#f82121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197128",
    "data-name": "Path 197128",
    d: "M103.315,174.177c27.832,3.183,56.1,4.924,83.971,2.216a1.561,1.561,0,0,0,.864-2.74,4.63,4.63,0,0,0-1.351-.745c.728-.832,1.264-34.062,2.941-76.4a1.149,1.149,0,0,0-1.143-1.2l-82.289-.38H106.3c-.984,0-4.257,5.414-4.656,6.014.208,23.911.542,48.29.753,72.213a1.033,1.033,0,0,0,.917,1.017ZM107.49,97.24l79.9.369c-.936,23.9-1.626,49.547-2.566,73.506a355.684,355.684,0,0,1-77.369-.8c.508-22.763.848-47.318.029-73.076Z",
    transform: "translate(-101.644 -86.141)",
    fill: "#f82121"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardRed1);
export default __webpack_public_path__ + "static/media/forwardRed-1.24e48c253893614d7931793a4771d004.svg";
export { ForwardRef as ReactComponent };